import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    descriptionWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    descriptionTicketNumber: {
        fontSize: "10px !important",
        fontWeight: 700,
        color: theme.palette.primary.dark,
    },
    description: {
        fontSize: "14px !important",
        fontWeight: 700,
        color: theme.palette.info.main,
    },
    inlineFormDatePicker: {
        width: "100%",
        backgroundColor: "white",
        "& .MuiOutlinedInput-root": {
            fontSize: "14px !important",
            height: 41,
        },
    },
    contentFormTextField: {
        width: "100%",
        height: theme.spacing(10),
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "14px",
            fontWeight: "400",
            backgroundColor: theme.palette.primary.main,
            "& .MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                padding: `${theme.spacing(2.125)} ${theme.spacing(3.5)} !important`,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "14px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
}));
